// extracted by mini-css-extract-plugin
export default {"FormWrapper":"customer-contact_FormWrapper__wWdtz","duplicateWarning":"customer-contact_duplicateWarning__DpRkW"};